// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"57":"892ebaf37cc39a56","100":"a2fdbebbb620a00c"}[chunkId] + ".js";
};